import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class InternalTransferDto {
    @ApiProperty()
    zoneId: number;
    @ApiProperty()
    rackId: number;
    @ApiProperty()
    saleOrderId: number;
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    varientId: number;
}